import React from 'react';
     import '/vercel/path0/docs/config/index.md?watch=parent';
export const demos = {
  'docs-config-demo-0': {
    component: React.memo(React.lazy(async function() {
  return {
    default: ()=>/*#__PURE__*/ React.createElement("div", {
            style: {
                width: 100,
                height: 100,
                color: '#fff',
                lineHeight: '100px',
                textAlign: 'center',
                fontSize: 30,
                background: 'linear-gradient(0, rgb(54, 138, 255) 0%, rgb(150, 239, 253) 100%)',
                borderRadius: '50%'
            }
        }, "dumi")
};

})),
    asset: {
  "type": "BLOCK",
  "id": "docs-config-demo-0",
  "refAtomIds": [],
  "dependencies": {
    "index.jsx": {
      "type": "FILE",
      "value": "export default () => (\n  <div\n    style={{\n      width: 100,\n      height: 100,\n      color: '#fff',\n      lineHeight: '100px',\n      textAlign: 'center',\n      fontSize: 30,\n      background:\n        'linear-gradient(0, rgb(54, 138, 255) 0%, rgb(150, 239, 253) 100%)',\n      borderRadius: '50%',\n    }}\n  >\n    dumi\n  </div>\n);"
    }
  },
  "entry": "index.jsx"
},
    context: {},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/vercel/path0/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
};